import { initaliseGA, sendEvent as sendGAEvent } from './ga';
// import { sendEvent as sendAmplitudeEvent, setAmplitudeKey } from './amplitute';
import { sendEvent as sendInternalEvent } from './internal';

let initialised = false;

export async function init(gaId: string, amplitudeKey?: string) {
    // if (!initialised && gaId && amplitudeKey) {
    //     initaliseGA(gaId);
    //     setAmplitudeKey(amplitudeKey);
    //     initialised = true;
    // }
    try {
        if (!initialised && gaId && (await areAnalyticsAllowed())) {
            initaliseGA(gaId);
            initialised = true;
        }
    } catch (error) {}
}

export async function sendEvent(name: string, data?: any) {
    try {
        sendInternalEvent(name, data);
        if (await areAnalyticsAllowed()) {
            sendGAEvent(name, data);
        }
    } catch (error) {}

    // Removed Amplitude event sending for now
    // sendAmplitudeEvent(name, data);
}

export async function areAnalyticsAllowed() {
    // Only mimas has cbsoptanon script currently
    if (process.env.PUBLIC_INSTANCE !== 'mimas') return true;
    try {
        return await window['cbsoptanon']?.ot?.getConsentPreferences(2);
    } catch (error) {
        console.log('areAnalyticsAllowed() - Could not getConsentPreferences so defaulting to false');
        return false;
    }
}
